<script>
import axios from 'axios'
import { Auth } from '@/api'
import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,
  data () {
    return {
      dataAttend: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 10,
              min: 0,
              max: 100,
              userCallback: function (label, index, labels) {
                // when the floored value is the same as the value we have a whole number
                if (Math.floor(label) === label) {
                  return label
                }
              }
            }
          }]
        }
      }
    }
  },
  mounted () {
    axios.get('crm/v1/statistic/sales_performance/1?period=yearly').then(response => {
      // console.log(response.data[0].data)
      response.data.forEach(item => {
        this.data1.push(item.data.total_sales)
        this.data2.push(item.data.number_of_leads)
        this.data3.push(item.data.number_of_calls)
        this.data4.push(item.data.missed_appointment)
        this.data5.push(item.data.appointment)
        this.data6.push(item.data.not_interested)
      })
      // console.log(this.dataAttend)
      this.renderChart({
        scaleStartValue: 0,
        labels: ['data type'],
        datasets: [
          {
            label: 'SALES',
            backgroundColor: '#1DE9B6',
            data: this.data1
          },
          {
            label: 'NUMBER OF LEADS',
            backgroundColor: '#A389D4',
            data: this.data2
          },
          {
            label: 'NUMBER OF CALLS',
            backgroundColor: '#04A9F5',
            data: this.data3
          },
          {
            label: 'MISS APPOINTMENT',
            backgroundColor: '#005F47',
            data: this.data4
          },
          {
            label: 'APPOINTMENT',
            backgroundColor: '#D4C889',
            data: this.data5
          },
          {
            label: 'NOT INTERESTED',
            backgroundColor: '#F58604',
            data: this.data6
          }
        ]
      }, this.options)
      // this.labels = response.data
      // console.log(response.data)
    }).catch(error => {
      console.log('error', error)
    })
    // Overwriting base render method with actual data.
  },
  created () {
  }
}
</script>